export default __webpack_public_path__ + "static/media/uVerifyMarcaNegativa.ad1a1904.png";